import {FC, useState, ReactNode} from 'react'
import moment from 'moment'
import {useFormContext, SubmitHandler} from 'react-hook-form'
import Button from 'jbc-front/components/Button'
import {Checkbox} from 'jbc-front/components/presenters/form/Checkbox'
import {Modal} from 'jbc-front/components/presenters/ui/Modal'
import {ButtonRow} from 'jbc-front/components/presenters/layout/ButtonRow'
import {Schema} from '../Presenter'
import styles from './AgreeModal.scss'

// @ts-ignore
import {isSignFreePeriod} from 'documents/Contract'

interface BillingAnnotateTextProps {
  isSignFree: boolean
  children: ReactNode
}

const BillingAnnotateText: FC<BillingAnnotateTextProps> = ({isSignFree, children}) =>
  isSignFree ? <span className={styles.freePeriod}>{children}</span> : <>{children}</>

interface AgreeModalProps {
  onSubmit: SubmitHandler<Schema>
  loading: boolean
}

export const AgreeModal: FC<AgreeModalProps> = ({onSubmit, loading}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const isSignFree = isSignFreePeriod(moment())
  const {register, handleSubmit} = useFormContext<Schema>()

  const {
    setValue,
    watch,
    formState: {isValid, isSubmitting},
  } = useFormContext<Schema>()
  const agreed = watch('agreed')

  const onClose = () => {
    setValue('agreed', false)
    setIsOpen(false)
  }

  return (
    <>
      <Button primary onClick={() => setIsOpen(true)} disabled={!isValid || isSubmitting || loading}>
        送信する
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} className={styles.modal}>
        <Modal.Header onClose={onClose}>送信の確認</Modal.Header>
        <Modal.Body>
          <p className="u-mb30">
            <BillingAnnotateText isSignFree={isSignFree}>
              「送信する」をクリックすると定価200円（税抜）が発生します。
            </BillingAnnotateText>
            <br />
            {isSignFree && (
              <span className={styles.annotation}>キャンペーン期間（2023年1月～2月）につき電子契約利用料が無料</span>
            )}
            <br />
            <BillingAnnotateText isSignFree={isSignFree}>
              ※各種無料キャンペーンの対象外です。無料期間に関わらず送信数に応じた課金が発生します。
            </BillingAnnotateText>
            <br />
            動作のご確認は
            <a
              className="u-txt-link"
              href="https://jobcan-lms.zendesk.com/hc/ja/articles/10060233784601"
              target="_blank"
              rel="noopener noreferrer"
            >
              こちら
            </a>
            をご参照ください。
            <br />
            <BillingAnnotateText isSignFree={isSignFree}>
              ※送信時点で課金対象となります。メール不達の場合も対象となりますので送信前に送信先アドレスのご確認をお願いします。
            </BillingAnnotateText>
            <br />
            ※署名依頼メールはGMOサインより送信されます。
            <br />「<span className={styles.email}>noreply@gmosign.com</span>
            」からのメールを受信できるようお願いします。
            <br />
            <BillingAnnotateText isSignFree={isSignFree}>
              ※電子契約利用料として毎月の労務HRサービス利用料と一緒に請求致します。
              <br />
              ※月額最低利用料金の算出に電子契約料は含まれません。
              <br />
              月額最低利用料金でご利用頂いているお客様は最低利用料＋電子契約利用料の請求となります。
            </BillingAnnotateText>
            <br />
            ※署名有効期限は30日間となります。
          </p>
          <div className={styles.agreeContainer}>
            <div className={styles.agreeCheck}>
              <Checkbox {...register('agreed')}>確認しました</Checkbox>
              <Checkbox {...register('isPublished')}>送信時にマイページに公開する</Checkbox>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <ButtonRow>
            <Button onClick={onClose}>キャンセル</Button>
            <Button primary onClick={handleSubmit(onSubmit)} disabled={!agreed || !isValid || isSubmitting}>
              送信する
            </Button>
          </ButtonRow>
        </Modal.Footer>
      </Modal>
    </>
  )
}
